import classNames from "classnames";
import "./OpticksSkeleton.css";

interface Props {
  height: number;
  width: number | string;
  isRounded?: boolean;
}

const OpticksSkeletonContainer = ({
  height,
  width,
  isRounded = false,
}: Props) => {
  return (
    <div
      className={classNames("opticks-skeleton opticks-skeleton-container", {
        rounded: isRounded,
      })}
      style={{ height: height, width: width }}
    ></div>
  );
};

export default OpticksSkeletonContainer;
